<template>
    <modal v-if="popup_open && popup_name === 'reminder_modal_mobile'" modal_name="reminder_modal_mobile" type="notification-reminder" @close="$emit('closeMenus')">
        <template v-slot:modal-content>
            <h3 class="tw-text-lg tw-font-semibold tw-pb-2 tw-mb-2px tw-pl-3">{{ $t('general.reminder') }}</h3>
            <div class="tw-w-full">
                <div class="tw-flex tw-gap-2 tw-flex-col tw-my-3">
                    <template v-for="option in formatted_reminders">
                        <dropdown-menu-item :key="option.name" :selected="option.value">
                            <label class="tw-relative tw-flex tw-items-center tw-cursor-pointer">
                                <div class="checkbox-container">
                                    <input type="checkbox" :value="option.value" class="checkbox" v-model="option.value">
                                    <i class="fal fa-check checkbox-button"></i>
                                </div>
                                <span class="tw-font-normal block tw-ml-2">{{ option.name }}</span>
                            </label>
                        </dropdown-menu-item>
                    </template>
                </div>
                <div class="general-button btn-v2 primary-button slim tw-mt-4 tw-pt-2px tw-mx-3" @click="saveReminders(id, type)">
                    {{ $t('notification.save') }}
                    <i class="fa fa-check"></i>
                </div>
            </div>
        </template>
    </modal>
</template>

<script>
    import Reminder from '../../mixins/Reminder';
    import Modal from "../../mixins/v2/Modal";

    export default {
        name: 'ReminderModal',

        mixins: [Modal, Reminder],

        props: ['id', 'type'],

        mounted() {
            this.setReminders(this.id, this.type);
        },
    };
</script>

<style lang="scss">
    .checkbox-container {
        @apply tw-relative tw-cursor-pointer;
        width: 16px;
        height: 16px;
        margin-bottom: 0;
        padding-left: 0;

        .checkbox {
            position: absolute;
            opacity: 0;
            cursor: pointer;
            height: 0;
            width: 0;
            top: 0;

            &:checked {
                & ~ .checkbox-button {
                    &::before {
                        @apply tw-opacity-100;
                    }
                }
            }
        }

        .checkbox-button {
            @apply tw-w-full tw-h-full tw-border tw-border-gray-400 tw-font-medium tw-relative;
            border-radius: 3px;
            font-size: 11px;
            transition: border-color .15s;
            padding: 0 !important;
            margin: 0 !important;

            &::before {
                @apply tw-opacity-0 tw-absolute;
                top: 52%;
                left: 50%;
                transform: translate(-50%, -48%);
                transition: opacity .15s;
            }
        }
    }
</style>
